import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from './wrapper';
import { media, TransitionMixin } from '../helpers';
import RightArrow from '../../images/icons/arrow-right.inline.svg';

const IconSectionContainer = styled.div`
    .icons-wrapper {
        padding: 0px 0 60px;
        display: flex;
        flex-wrap: wrap;
        ${media.medium`padding: 50px 0 60px;`}

        .item-container {
            flex: 1;
            text-align: center;
            margin-bottom: 30px;
            flex: 0 0 50%;
            ${media.small`flex: 0 0 33.33%;`}
            ${media.large`flex: 1;`}
            .inner-wrap {
                .image-container {
                    margin: 0px auto 15px;
                    max-width: 60px;
                    img {
                        object-fit: contain !important;
                    }
                }

                .content-container {
                    p {
                        font-size: 0.9rem;
                        color: rgb(0, 0, 0);
                        font-weight: bold;
                        line-height: 1.2;
                        max-width: 180px;
                        margin: 0px auto;
                    }
                }
            }
        }
    }
    .btn-container {
        text-align: center;
        padding: 0 0 60px;
        .btn {
            margin-bottom: 20px;

            &.lg {
                a {
                    color: #fff;
                    background-color: #f74d33;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                    text-decoration: none;
                    padding: 20px 30px;
                    box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                    border-radius: 5px;
                    font-size: 1.5rem;
                    display: inline-block;
                    border: 1px solid #f74d33;
                    ${TransitionMixin('.25s')}

                    &:hover {
                        background-color: transparent;
                        color: #f74d33;

                        span {
                            text-align: left;
                            svg {
                                path {
                                    fill: #f74d33;
                                }
                            }
                        }
                    }

                    span {
                        position: relative;
                        top: 3px;
                        margin-left: 40px;
                    }
                }
            }

            &.sm {
                margin-bottom: 30px;
                a {
                    color: #fff;
                    background-color: #1c7775;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                    text-decoration: none;
                    padding: 20px 30px;
                    box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                    border-radius: 5px;
                    font-size: 1.1rem;
                    display: inline-block;
                    border: 1px solid #1c7775;
                    ${TransitionMixin('.25s')}
                    &:hover {
                        background-color: transparent;
                        color: #1c7775;
                    }
                }
            }
        }
    }
    p {
        font-size: 0.9rem;
        margin: 10px 0 0;
        color: #000;
    }
`;

const IconSection = ({ content, icons }) => {
    const { smallButton, largeButton, footerCaption } = content || {};
    return (
        <IconSectionContainer>
            <Wrapper className="icons-wrapper">
                {icons &&
                    icons.map((icon, index) => {
                        const { iconImage, iconCaption } = icon || {};
                        return (
                            <div className="item-container" key={index}>
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                iconImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                        />
                                    </div>
                                    <div className="content-container">
                                        <p>{iconCaption}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="btn-container">
                <div className="btn lg">
                    <Link to={largeButton.url}>
                        {largeButton.title}{' '}
                        <span>
                            <RightArrow />
                        </span>
                    </Link>
                </div>
                <div className="btn sm">
                    <Link to={smallButton.url}>{smallButton.title}</Link>
                </div>
                <p>{footerCaption}</p>
            </Wrapper>
        </IconSectionContainer>
    );
};

export default IconSection;
